import type { LucideIcon } from "lucide-react";
import { Gavel, Gift, Home, Layers, ShoppingBag, Store, Ticket, Trophy, User } from "lucide-react";
import { isMarketplaceLive } from "../lib/marketplace";
import type { BootstrapConfig } from "@gaole/shared";

export interface StorefrontNavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  module?: string;
  auth?: boolean;
  mobileOnly?: boolean;
  desktopOnly?: boolean;
}

export function mobileNavItems(
  moduleEnabled: (k: string) => boolean,
  config: BootstrapConfig | null = null,
): StorefrontNavItem[] {
  return [
    { to: "/", label: "Home", icon: Home },
    ...(moduleEnabled("ecommerce") ? [{ to: "/shop", label: "Shop", icon: ShoppingBag, module: "ecommerce" }] : []),
    ...(isMarketplaceLive(config, moduleEnabled)
      ? [{ to: "/market", label: "Market", icon: Store, module: "marketplace" }]
      : []),
    ...(moduleEnabled("packs") ? [{ to: "/packs", label: "Packs", icon: Gift, module: "packs" }] : []),
    ...(moduleEnabled("raffles") ? [{ to: "/raffles", label: "Raffles", icon: Ticket, module: "raffles" }] : []),
    ...(moduleEnabled("auctions") ? [{ to: "/auctions", label: "Auctions", icon: Gavel, module: "auctions" }] : []),
  ].slice(0, 5) as StorefrontNavItem[];
}

export function desktopNavItems(
  moduleEnabled: (k: string) => boolean,
  user: boolean,
  config: BootstrapConfig | null = null,
): StorefrontNavItem[] {
  const items: StorefrontNavItem[] = [
    { to: "/", label: "Home", icon: Home },
    ...(moduleEnabled("ecommerce") ? [{ to: "/shop", label: "Shop", icon: ShoppingBag, module: "ecommerce" }] : []),
    ...(isMarketplaceLive(config, moduleEnabled)
      ? [{ to: "/market", label: "Marketplace", icon: Store, module: "marketplace" }]
      : []),
    ...(moduleEnabled("packs") ? [{ to: "/packs", label: "Packs", icon: Gift, module: "packs" }] : []),
    ...(moduleEnabled("raffles") ? [{ to: "/raffles", label: "Raffles", icon: Ticket, module: "raffles" }] : []),
    ...(moduleEnabled("auctions") ? [{ to: "/auctions", label: "Auctions", icon: Gavel, module: "auctions" }] : []),
  ];
  if (user && moduleEnabled("collection")) {
    items.push({ to: "/inventory", label: "Collection", icon: Layers, auth: true, module: "collection" });
  }
  if (moduleEnabled("packs")) {
    items.push({ to: "/leaderboard", label: "Leaderboard", icon: Trophy, module: "packs" });
  }
  items.push({ to: user ? "/account" : "/login", label: user ? "Account" : "Sign in", icon: User, auth: user });
  return items;
}
